__turbopack_context__.v({
  "events": "_58UwcG_events",
  "events_expand_button": "_58UwcG_events_expand_button",
  "events_title": "_58UwcG_events_title",
  "events_wrapper": "_58UwcG_events_wrapper",
});
